import { gql } from '@apollo/client'

export const FIXTURES_LIST = gql`
  query FetchFixuresData($input: oFixuresInput) {
    fetchFixuresData(input: $input) {
      _id
      oTeamScoreA {
        sScoresFull
        oTeam {
          _id
          sAbbr
          sTitle
          oImg {
            sUrl
          }
        }
      }
      oTeamScoreB {
        sScoresFull
        oTeam {
          _id
          sAbbr
          sTitle
          oImg {
            sUrl
          }
        }
      }
      oWinner {
        _id
      }
      sTitle
      sSubtitle
      sResult
      nLatestInningNumber
      dStartDate
      sStatusStr
      oStatus {
        sValue
        sText
      }
      sStatusNote
      sFormatStr
      oFormat {
        sText
        sValue
      }
      oVenue {
        sName
        sLocation
      }
      oSeries {
        sTitle
        sSeason
        oSeo {
          sSlug
        }
        oCategory {
          oSeo {
            sSlug
          }
        }
      }
      oSeo {
        sSlug
      }
      oMatchSeos {
        oSeo {
          eSubType
          sSlug
        }
      }
    }
  }
`

export const FETCH_TEAM_VENUE = gql`
query FetchSeriesData($input: oSeriesIdInput) {
  fetchSeriesData(input: $input) {
    aTeams {
      _id
      sTitle
      sAbbr
      sCountry
    }
    iSeriesId
    aVenues {
      _id
      sLocation
      sName
      sCity
    }
    oSeries {
      _id
      sTitle
      sCustomSeriesDescription
      bIsCustomSeriesDescription
      sSrtTitle
    }
  }
}
`
export const FETCH_SERIES_DESCRIPTION = gql`
query FetchSeriesData($input: oSeriesIdInput) {
  fetchSeriesData(input: $input) {
    oSeries {
      sCustomSeriesDescription
      bIsCustomSeriesDescription
    }
  }
}
`
